import DuckModule from '../duckModule';

export default DuckModule({
    store: 'filtro-log-accessi',
    initialState: {
        currentSelection: 0,
        selection: [],
        selectedRowIndex: -1,
        selected_log_accesso: {},
        filters: [],
        sorting: [{ columnName: 'DataAccesso', direction: 'desc' }],
        currentPage: 0,
        pageSize: 15,
        pageSizes: [5, 15, 25, 50, 100],
        expandedRowIds: [],
        columnWidths: [
            { columnName: 'ID', width: 100 },
            { columnName: 'SerialNumber', width: 85 },
            { columnName: 'ProductKey', width: 225 },
            { columnName: 'IP', width: 140 },
            { columnName: 'MAC', width: 145 },
            { columnName: 'DataAccesso', width: 200 },
            { columnName: 'Major', width: 85 },
            { columnName: 'Minor', width: 85 },
            { columnName: 'Build', width: 85 },
            { columnName: 'SP', width: 85 },
            { columnName: 'Patch', width: 85 },
            { columnName: 'CodiceUtente', width: 180 },
        ],
    },
    types: [ 'GRID_STATE_CHANGE', 'HANDLE_ROW_SELECTION', 'HANDLE_EXPANDED_ROW', 'RESET_FILTERS', 'SET_SELECTED_LOG_ACCESSO' ],
}).extend({
    reducer: (state, { type, payload }, { types }) => {
        switch (type) {
            case types.RESET_FILTERS:
                return {
                    ...state,
                    currentSelection: 0,
                    selection: [],
                    selectedRowIndex: -1,
                    selected_log_accesso: {},
                    filters: [],
                    sorting: [{ columnName: 'DataAccesso', direction: 'desc' }],
                    currentPage: 0,
                };
            case types.GRID_STATE_CHANGE:
                return {
                    ...state,
                    [payload.newStateName]: payload.newStateValue,
                };


            case types.HANDLE_ROW_SELECTION:    //Posso selezionare solo una riga per volta
                const newIndex = payload.newSelection
                    .find(selected => state.selection.indexOf(selected) === -1);

                if (newIndex !== undefined)
                    return {
                        ...state,
                        selection: [newIndex],
                        selectedRowIndex: newIndex,
                    };
                else if (newIndex === undefined)
                    return {
                        ...state,
                        selection: [],
                        selectedRowIndex: -1,
                    };
                else return state;


            case types.SET_SELECTED_LOG_ACCESSO:
                if (state.selectedRowIndex !== -1)
                    return {
                        ...state,
                        selected_log_accesso: payload.selected_log_accesso,
                    };
                else return {
                    ...state,
                    selected_log_accesso: {},
                };


            case types.HANDLE_EXPANDED_ROW:
                const newRowIndex = payload.newExpandedRow
                    .find(selected => state.expandedRowIds.indexOf(selected) === -1);

                if (newRowIndex !== undefined)
                    return {
                        ...state,
                        expandedRowIds: [newRowIndex],
                        selection: [newRowIndex],
                    };
                else if (newRowIndex === undefined)
                    return {
                        ...state,
                        expandedRowIds: [],
                    };
                else return state;
            default:
                return state;
        }
    },
    creators: ({ types }) => ({
        handleRowSelection: (newSelection) => ({
            type: types.HANDLE_ROW_SELECTION,
            payload: { newSelection },
        }),
        handleExpandedRow: newExpandedRow => ({
            type: types.HANDLE_EXPANDED_ROW,
            payload: { newExpandedRow },
        }),
        onGridAction: (newStateName, newStateValue) => ({
            type: types.GRID_STATE_CHANGE,
            payload: { newStateName, newStateValue },
        }),
        resetFilters: () => ({
            type: types.RESET_FILTERS,
        }),

        
        setSelectedLogAccesso: (selected_log_accesso) => ({
            type: types.SET_SELECTED_LOG_ACCESSO,
            payload: { selected_log_accesso },
        }),
        
    }),
});
